import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-smartphone",
  "use": "icon-si-glyph-smartphone-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-smartphone\" id=\"icon-si-glyph-smartphone\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1128</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M10.001,0 L5,0 C3.897,0 3.003,0 3.003,1 L3.003,15 C3.003,16.119 3.898,15.947 5,15.947 L10.001,15.947 C11.104,15.947 12,16.119 12,15 L12,1 C12,0 11.104,0 10.001,0 L10.001,0 Z M8.125,15.188 L6.895,15.188 L6.895,13.813 L8.125,13.813 L8.125,15.188 L8.125,15.188 Z M11.037,13 L4,13 L4,1 L11.037,1 L11.037,13 L11.037,13 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-smartphone.svg
// module id = 0wft
// module chunks = 62